var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30724 11.4231C11.1749 11.4231 13.4995 9.09839 13.4995 6.23076C13.4995 3.36313 11.1749 1.03845 8.30724 1.03845C5.4396 1.03845 3.11493 3.36313 3.11493 6.23076C3.11493 9.09839 5.4396 11.4231 8.30724 11.4231Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30722 9.34613C10.0278 9.34613 11.4226 7.95132 11.4226 6.23074C11.4226 4.51016 10.0278 3.11536 8.30722 3.11536C6.58664 3.11536 5.19183 4.51016 5.19183 6.23074C5.19183 7.95132 6.58664 9.34613 8.30722 9.34613Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.423 10.3843V15.5769L8.30713 14.0192L5.1922 15.5769V10.3847",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/Medal.4d8fc6df887016b4b7f6fe020394fb89.svg";
export { ForwardRef as ReactComponent };